import React, { FC } from "react";
import { useDialogShadow } from "@evergis/ui";
import { AddProxyServiceProvider } from "../../../AddProxyService/components/AddProxyServiceProvider";
import { ProxyServiceType } from "../../../AddProxyService/components/types";
import { LayerReferencesProvider } from "../../../DialogComponents/Attributes/LayerReferences/LayerReferencesProvider";
// eslint-disable-next-line max-len
import { DialogTitle } from "../../../DialogComponents/DialogTitle";
import { FullScreenDialog } from "../../../DialogComponents/FullScreenDialog";

import { useLayerInfoWithUpdate } from "../../hooks/useLayerInfoWithUpdate";
import { isProxyService } from "../../../../../interfaces/resourceInfo";
import { useContext } from "./hooks/useContext";
import { PostgresLayerSettings } from "./PostgresLayerSettings";
import { ProxyLayerSettings } from "./ProxyLayerSettings";

export const LayerSettings: FC = () => {
  const [{ layer }] = useLayerInfoWithUpdate();
  const isProxyLayer = isProxyService(layer);
  const context = useContext(isProxyLayer, layer?.proxy?.sourceType as ProxyServiceType);
  const dialogShadow = useDialogShadow();
  const { shadows } = dialogShadow;

  return (
    <FullScreenDialog dialogContext={context}>
      <DialogTitle displayShadow={shadows.upper} />
      {isProxyLayer ? (
        <AddProxyServiceProvider layer={layer}>
          <ProxyLayerSettings layer={layer} dialogShadow={dialogShadow} />
        </AddProxyServiceProvider>
      ) : (
        <LayerReferencesProvider layer={layer}>
          <PostgresLayerSettings dialogShadow={dialogShadow} />
        </LayerReferencesProvider>
      )}
    </FullScreenDialog>
  );
};
